import React, { useCallback, useEffect, useState } from "react";

import { getAllAdminModules } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { MODULE_TYPE } from "consts";

import { AdminHead, AdminSection, AdminTable, Button, Col, Icon, MainPage, Row } from "components";

export const ModuleList = () => {
  const [loading, setLoading] = useState(true);
  const [modules, setModules] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllModules = useCallback(() => {
    getAllAdminModules({
      signal,
    })
      .then((res) => {
        setModules(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllModules();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${modules.length} modules`}
        description="View or update HP modules here. New modules cannot be added via the admin."
        extra={
          <Button size="small" type="secondary" href="/programs/modules/configure">
            <Icon iconName="tabler/settings" />
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminSection headline="Field Modules" />
          <AdminTable
            dataSource={modules.filter((module) => module?.type === MODULE_TYPE.FIELD)}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/module/update/",
                },
              ],
              exclude: ["module", "image", "icon", "shortDescription", "longDescription", "utc", "updated", "beta"],
            }}
          />
        </Col>
        <Col>
          <AdminSection headline="Farm Modules" />
          <AdminTable
            dataSource={modules.filter((module) => module?.type === MODULE_TYPE.FARM)}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/module/update/",
                },
              ],
              exclude: ["module", "image", "icon", "shortDescription", "longDescription", "utc", "updated", "beta"],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
